import { render, staticRenderFns } from "./UserAudio.vue?vue&type=template&id=0a027402&scoped=true&"
import script from "./UserAudio.vue?vue&type=script&lang=js&"
export * from "./UserAudio.vue?vue&type=script&lang=js&"
import style0 from "./UserAudio.vue?vue&type=style&index=0&id=0a027402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a027402",
  null
  
)

export default component.exports